
export default function HeroSection() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1A1F2E] to-[#2D3548]">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-64 h-64 bg-[#C9A961] rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-[#C9A961] rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="inline-block px-4 py-2 bg-[#C9A961]/20 border border-[#C9A961]/30 rounded-full mb-6">
          <span className="text-[#C9A961] text-sm font-medium">Travel Guides & Insights</span>
        </div>
        
        <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
          Explore Our Travel Blog
        </h1>
        
        <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
          Discover destination tips, cultural insights, and expert advice to make your journey 
          to the Middle East and beyond truly unforgettable.
        </p>
      </div>
    </section>
  );
}
